import React from 'react';
import { Box, Divider } from '@mui/material';
import { LocationSelector } from './selectors/LocationSelector';
import { CapacityFilterSelector } from './selectors/CapacityFilterSelector';
import { EventDateSelector } from './selectors/EventDateSelector';
import { EventTimeSelector } from './selectors/EventTimeSelector';
import { useFilterBarContext } from './providers/FilterBarProvider';

interface WebFilterBarProps {
  hasLocationSearch: boolean;
}

export const WebFilterBar = ({
  hasLocationSearch,
}: WebFilterBarProps) => {
  const {
    locationQuery,
    onChangeLocationQuery,
    capacityFilterValues,
    onSubmitCapacityFilter,
    onCancelCapacityFilter,
    eventDate,
    onChangeEventDate,
    startTime,
    onChangeStartTime,
    clearStartTime,
    endTime,
    onChangeEndTime,
    clearEndTime,
    expressBookSettings,
    hoursOfOperation,
  } = useFilterBarContext();
  const renderLocationSection = () => {
    if (!hasLocationSearch) return null;
    
    return (
      <>
        <LocationSelector
          locationQuery={locationQuery || ''}
          onChangeLocationQuery={onChangeLocationQuery || (() => {})}
        />
        <Separator />
      </>
    );
  };

  return (
    <Box
      sx={{
        padding: '0px',
        // width: '100%',
        maxWidth: '960px',
        margin: '24px',
      }}
    >
      <Box
        component={hasLocationSearch ? 'form' : 'div'}
        id={hasLocationSearch ? 'location-search-filter-bar' : undefined}
        role="search"
        height="70px"
        sx={{
          margin: '0px',
          borderRadius: '50px',
          border: '1px solid #E6E6E6',
          background: '#FFF',
          boxShadow: hasLocationSearch 
            ? '0px 2px 8px 0px rgba(0, 0, 0, 0.1)' 
            : '0px 2px 8px 0px rgba(0, 0, 0, 0.10)',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        {renderLocationSection()}

        <EventDateSelector
          eventDate={eventDate}
          onChangeEventDate={onChangeEventDate}
          expressBookSettings={expressBookSettings}
          hoursOfOperation={hoursOfOperation}
        />
        <Separator />

        <EventTimeSelector
          eventDate={eventDate}
          startTime={startTime || null}
          endTime={endTime || null}
          onChangeStartTime={onChangeStartTime}
          onChangeEndTime={onChangeEndTime}
          clearStartTime={clearStartTime}
          clearEndTime={clearEndTime}
          expressBookSettings={expressBookSettings}
          hoursOfOperation={hoursOfOperation}
        />
        <Separator />

        <CapacityFilterSelector
          initialValues={capacityFilterValues}
          onSubmit={onSubmitCapacityFilter}
          onCancel={onCancelCapacityFilter}
        />
      </Box>
    </Box>
  );
};

const Separator = () => (
  <Divider orientation="vertical" flexItem sx={{ margin: '15px 0px' }} />
);
